import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4814d4f2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4814d4f2')) {
      api.createRecord('4814d4f2', component.options)
    } else {
      api.reload('4814d4f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4814d4f2", function () {
      api.rerender('4814d4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Dashboard/index.vue"
export default component.exports